import { MediaElementActionPayload, MediaElementApi } from '../types';

export enum MediaApiActions {
  UPDATE_MEDIA_API_STATE = 'updateMediaApiState',
}

export const setMediaApi = (api: MediaElementApi): MediaElementActionPayload => ({
  payload: api,
  type: MediaApiActions.UPDATE_MEDIA_API_STATE,
});
